// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "gdsTotalPrice-3n4MJ";
var _3 = "serviceSummary__wrapper-3Vjfj";
export { _1 as "__esModule", _2 as "gdsTotalPrice", _3 as "serviceSummary__wrapper" }
export default { "__esModule": _1, "gdsTotalPrice": _2, "serviceSummary__wrapper": _3 }
